import React, { useState, useEffect } from "react";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import { Grid, Container, Box, Stack, ListItemText } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getDocsList, getFormLibrariesList } from "../../../../redux/docs/index.js";
import HeaderDocs from "./headerDocs/index.js";
import { Folder, Done, FilePresent } from "@mui/icons-material";
import Avatar from "../../../../components/uiElements/avatar/index";
import moment from "moment";
import ResponseAlert from "../../../../components/responseAlert/index.js";
import { deleteFolder } from "../../../../redux/docs/addfolderapi.js";
import { useNavigate, useParams } from "react-router-dom";
import { DataGridPro } from "@mui/x-data-grid-pro";
import TableSkeleton from "../../../../components/loader/tableLoader.jsx";

const FormsListing = ({ classes }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { id } = useParams();

  const [docaArray, setDocsArr] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [selectedCheckboxIds, setSelectedCheckboxIds] = useState([]);
  const [pageSize, setPageSize] = useState(5);

  const [openerror, setOpenerror] = useState(false);
  const [alertType, setAlertType] = useState();
  const [alertMessage, setAlertMesage] = useState();
  const [searchValue, setSearchValue] = useState("");
  const forms = useSelector((item) => item.DocsLibrary.forms);
  const agents = useSelector((state) => state.users.storedListOfUsers.list.filter((user) => user.is_agent === true && user.status === "active"));

  const columns = [
    {
      field: "name",
      headerName: "Name",
      renderCell: (params) => {
        return (
          <>
            <Grid container onClick={() => redirectDetails(params.row)} className={classes.mAlign} alignItems="center" xs="auto">
              {params.row.type === "folder" ? (
                <>
                  <Folder sx={{ color: "rgba(0, 0, 0, 0.54)", mr: "15px" }} />
                  <span>{params.row.name}</span>
                </>
              ) : (
                <>
                  <FilePresent sx={{ color: "rgba(0, 0, 0, 0.54)", mr: "15px" }} />
                  <span> {params.row?.name}</span>
                </>
              )}
            </Grid>
          </>
        );
      },
      width: 400,
      editable: false,
      sortable: true,
    },
  ];

  const handleOpen = () => {
    setOpen(true);
  };

  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  useEffect(() => {
    dispatch(getFormLibrariesList(id));
  }, [id]);

  const redirectDetails = (data) => {
    if (data.type === "folder") {
      navigate(`/docs/library/${data.id}`);
    } else {
      navigate(`/docs/library/${data.doc_repo_id}/form/${data.id}`);
    }
  };

  const handlePageSizeChange = (params) => {
    setPageSize(params);
  };

  const archiveFunction = () => {
    if (selectedCheckboxIds?.length > 0) {
      Promise.all(
        selectedCheckboxIds?.length &&
          selectedCheckboxIds.map(async (forlderId) => {
            await dispatch(deleteFolder(forlderId));
          })
      ).then(() => {
        setDocsArr([]);
        setOpenerror(true);
        setAlertType("success");
        setAlertMesage("You have successfully Archive the folder");
      });
    } else {
      setOpenerror(true);
      setAlertType("error");
      setAlertMesage("Please select folders or folder");
    }
  };
  return (
    <div className={classes.pageRoot}>
      <HeaderDocs
        addFolderModal={handleOpen}
        selectedCheckboxIds={selectedCheckboxIds}
        archiveFunction={archiveFunction}
        handleSearchInputChange={handleSearchInputChange}
      />
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Box sx={{ height: "80vh", width: "100%" }}>
              <DataGridPro
                loading={forms.isLoading}
                components={{
                  LoadingOverlay: TableSkeleton,
                }}
                rows={
                  forms?.data?.length && searchValue
                    ? forms.data.filter((row) => row.name.toLowerCase().startsWith(searchValue.toLowerCase()))
                    : forms?.data?.length
                    ? [...forms?.data]
                    : []
                }
                columns={columns}
                pageSize={pageSize}
                checkboxSelection={true}
                rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]}
                onRowSelectionModelChange={(itm) => setSelectedCheckboxIds(itm)}
                handlePageSizeChange={handlePageSizeChange}
              />

              <ResponseAlert setOpen={setOpenerror} open={openerror} alertType={alertType} alertMessage={alertMessage} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default withStyles(styleSheet, { name: "DocsStyle" })(FormsListing);
